import { Component, Input } from '@angular/core'
import { JobResultItem } from '../../../types'
import { CmsLinkType } from '../../../../enums/cms-link-type'

@Component({
  selector: 'mb-cms-search-result-item-job',
  templateUrl: './cms-search-result-item-job.component.html',
  styleUrls: ['./cms-search-result-item-job.component.scss']
})
export class CmsSearchResultItemJobComponent {
  @Input() result: JobResultItem | undefined
  protected readonly cmsLinkType = CmsLinkType
}
